import {
    FilePdfOutlined
} from '@ant-design/icons';
import { PDFViewer } from "@react-pdf/renderer";
import { Button } from "antd";
import CommonOverlayComponent from "commons/CommonOverlayComponent";
import { useState } from "react";



const PdfExport = ({ templateComponent }) => {

    const [showModal, setShowModal] = useState(false)

    return (
        <>
            <Button icon={<FilePdfOutlined />} type='primary' onClick={() => setShowModal(true)}>Visualizza pdf</Button>
            <CommonOverlayComponent
                title={'Preview PDF'}
                className="pdfOverlay"
                type={'drawer'}
                placement="right"
                width={'50%'}
                destroyOnClose
                // mask={false}
                cancelText="Chiudi"
                visible={showModal}
                okText="Conferma e Salva"
                onCancel={() => setShowModal(false)}
            >
                <PDFViewer width={'100%'} height='100%'>
                    {templateComponent}
                </PDFViewer>
            </CommonOverlayComponent>
        </>
    )
}

export default PdfExport;